//Based on basic principle from: https://www.codementor.io/angularjs/tutorial/create-dropdown-control
//Usage: <dropdown placeholder="Colour..." list="colours" ng-model="colour" labelProperty="property" modelproperty="rgb" max-height="20rem" expandup="true" onselect="selectcalback" data-required="isRequired"></dropdown>
//set class="expandup" to make expand upwards instead
//labelProperty is optional, if not provided assumes object is a flat array of labels
//modelproperty is optional. If not provided, will check equivalence of model against list entries via properties.
//If provided, uses modelproperty of list items and returns that property as the model value
//max-height is optional and is applied as-is in the style="max-height:xx;" attribute
//headerProperty will create fake entries with the headerProperty value on first entry and those entries
//where the previous entry's headerProperty is different. Must be used in conjunction with labelProperty
//searchbox enables entering of text, but you still have to click an entry
//onsearch is the callback that returns the searched text.
//selectdefault = if only one item, automatically select it
//required - if required, sets the hidden field's value to 1 or null depending on whether the selected Item's value matches emptyValue or not, using ng-required internally

//<taginput data-list="filteredListTo" data-OnSearch="filterSourceList" data-tagproperty="'Name'" data-valueproperty="'Email'" data-tagcallback="tagsUpdated" data-callbacklist="'To'" data-modellist="tmp_ContacteeList.To" data-staticlist="isCustomerReply" data-addentries="true" data-addentrycallback="addContactee()" data-forcemodel="newContactee"></taginput>

(function () {
    'use strict';
    // Generic methods common to all instances of this component

    //Validation based on: http://plnkr.co/edit/octwC4BCuXLmRhHgLD8T?p=preview
    function _isRequiredValid($ctrl) {
        //If the required attribute is set on the directive, and it's not read only, make the field required if the value is empty
        if ($ctrl.requiredfield && !$ctrl.readonly) {
            //If this entry is empty, required field should be true (as long as the required attribute is set)
            //console.log('$ctrl.selectedItem', $ctrl.selectedItem)

            return !angular.equals((!!$ctrl.modelProperty && !!$ctrl.selectedItem ? $ctrl.selectedItem[$ctrl.modelProperty] : $ctrl.selectedItem), $ctrl.emptyValue);
        }
        //If directive is not a required field, return that the required form value is not required
        return true;
    }

    function _updateValidity($ctrl) {
        //Set the required status (as reported to the containing form) based on whether a valid value has been selected
        $ctrl.model.$setValidity("", _isRequiredValid($ctrl));
        //SetValidity key string "required" removed to set base validity.
    }

    function _showDefaultItem($ctrl) {
        if ($ctrl.selectDefault && $ctrl.displayList.length == 1) {
            $ctrl.select($ctrl.displayList[0], true);//select item, ignoring callback.
        }
    }

    function _findItemInList($ctrl, item) {
        if ($ctrl.list && $ctrl.list.length) {
            for (var entry of $ctrl.list) {
                if (!$ctrl.modelProperty) {
                    if (angular.equals(item, entry)) {
                        return entry;
                    }
                } else {
                    if (angular.equals(item, entry[$ctrl.modelProperty])) {
                        return entry;
                    }
                }
            }
        }
        //This will have returned if found, otherwise return null
        return null;
    }



    function _rebuildDisplayList($ctrl) {
        // Filter the source list to not include items that are in the emptyValue (if provided)
        var srcListCopy = !!$ctrl.list ? angular.copy($ctrl.list.filter(function (i) {
            return $ctrl.emptyValue == null || !angular.equals((!!$ctrl.modelProperty ? i[$ctrl.modelProperty] : i), $ctrl.emptyValue);
        }) || []) : [];

        if (srcListCopy.length && $ctrl.groupProperty && $ctrl.labelProperty) {
            var newList = [];
            for (var i = 0; i < srcListCopy.length; i++) {

                if (i === 0 || srcListCopy[i - 1][$ctrl.groupProperty] !== srcListCopy[i][$ctrl.groupProperty]) { //first row or different to previous group
                    var headerobj = { readonly: true, header: true, separator: !$ctrl.showGroupHeader };
                    headerobj[$ctrl.labelProperty] = srcListCopy[i][$ctrl.groupProperty];
                    newList.push(headerobj);
                }
                newList.push(srcListCopy[i]);
            }
            return newList;
        } else {
            return srcListCopy;
        }

    }

    function _updateDisplayedItem($ctrl) {
        var foundItem = _findItemInList($ctrl, $ctrl.model.$viewValue);
        if (foundItem === null) {
            $ctrl.selectedItem = angular.copy($ctrl.emptyValue);
        } else {
            $ctrl.selectedItem = foundItem;
        }

        var modelIsEmptyValue = angular.equals($ctrl.model.$viewValue, $ctrl.emptyValue);
        var selectedIsEmptyValue = angular.equals($ctrl.selectedItem, $ctrl.emptyValue);

        $ctrl.isPlaceholder = (modelIsEmptyValue || selectedIsEmptyValue || (!!$ctrl.labelProperty && typeof ($ctrl.selectedItem[$ctrl.labelProperty]) === 'undefined'));

        _updateValidity($ctrl);

        if (!$ctrl.isPlaceholder) {
            if ($ctrl.labelProperty && !selectedIsEmptyValue) {
                $ctrl.display = $ctrl.selectedItem[$ctrl.labelProperty];
            } else {
                $ctrl.display = $ctrl.selectedItem;
            }
        }

        // If the value in the model is not found (and has legitimately been passed and is not the empty value), trigger the invalid callback
        if (foundItem === null && !modelIsEmptyValue && (typeof $ctrl.model.$viewValue !== 'undefined' && $ctrl.model.$viewValue !== null)) {
            //console.log('foundItem', foundItem);
            //console.log('modelIsEmptyValue', modelIsEmptyValue);
            //console.log('selectedIsEmptyValue', selectedIsEmptyValue);
            //console.log('Empty', $ctrl.emptyValue);
            //console.log('viewvalue', $ctrl.model.$viewValue);
            //console.log('selectedItem', $ctrl.selectedItem);
            $ctrl.onInvalid({ $event: { value: $ctrl.model.$viewValue } });
        }
    }

    var dropdownController = function ($document, $timeout, $element, $scope) {
        var $ctrl = this;

        //Internal variables
        var _initialised = false;
        var _searchTimer = null;

        //Init function
        $ctrl.$onInit = $onInit;
        $ctrl.$postLink = $postLink;
        $ctrl.$onChanges = $onChanges;
        $ctrl.$onDestroy = $onDestroy;

        //Set defaults

        //Frontend variables
        $ctrl.opened = false;//Has the dropdown been opened? Sets on first open.

        $ctrl.ddOpen = false;
        $ctrl.display = null;//holds shown value
        $ctrl.listVisible = false;
        $ctrl.displayList = [];
        //TODO try the below line
        //$ctrl.displayList = _rebuildDisplayList($ctrl);

        $ctrl.searchBox = typeof $ctrl.onSearch !== 'undefined';//Set to searchable if either the model or the search callback is set on load
        $ctrl.searchText = ''; //Text entered in search field
        //TODO!
        $ctrl.isPlaceholder = true;

        $ctrl.selectedItem = null; //placeholder for selected entry in list

        // #region functionality




        $ctrl.equal = function (var1, var2) {
            return angular.equals(var1, var2);
        };

        $ctrl.searchChanged = function () {
            $ctrl.selectedItem = $ctrl.emptyValue;//clear selection

            if ($ctrl.searchTimeout > 0) {
                // Do not fire search method immediately on change.
                // prevent instant triggering by using a rolling timeout
                if (_searchTimer) $timeout.cancel(_searchTimer);
                _searchTimer = $timeout(function () {
                    $ctrl.onSearch({ $event: { text: $ctrl.searchText } });//return searched text to controller
                }, $ctrl.searchTimeout);//end timeout
            } else {
                $ctrl.onSearch({ $event: { text: $ctrl.searchText } });//return searched text to controller
            }
        };

        $ctrl.select = function (item, noselectcallback) {
            if (!$ctrl.readonly) {
                $ctrl.listVisible = false;
                $ctrl.ddOpen = false;
                $document.off('click', _documentClick);//unbind the click-away event

                if (item && !item.readonly && !angular.equals(item, $ctrl.emptyValue)) {
                    //console.log('first clause', item, typeof item);
                    $scope.$evalAsync(function () {
                        $ctrl.selectedItem = item;

                        //$ctrl.isPlaceholder = false;
                        //DO not update the model - the parent controller should do this, which will trigger validation
                        //_updateValidity($ctrl);
                        //$ctrl.model.$setViewValue(viewValue);//on selection set model to either the property or list item

                        //No longer update the search box text - that should be done by the controller based on the properties of the selected object.
                        //if ($ctrl.searchBox) {
                        //set textbox content if using searchbox - must be labelProperty or text if it doesn't have that
                        //$ctrl.searchText = angular.copy(($ctrl.labelProperty ? item[$ctrl.labelProperty]: item));
                        //}

                        if (!noselectcallback) {
                            $ctrl.onSelect({ $event: { item: item } }); //Return the item as the viewValue (be that the item itself or its model property)
                            //$ctrl.onSelect(item, $element);
                        }
                    });
                } else if (angular.equals(item, $ctrl.emptyValue) || item === null) {
                    //console.log('second clause', item, typeof item);
                    $scope.$evalAsync(function () {
                        //$ctrl.isPlaceholder = true;
                        $ctrl.selectedItem = $ctrl.emptyValue;
                        //DO not update the model - the parent controller should do this, which will trigger validation
                        //_updateValidity($ctrl);
                        //$ctrl.model.$setViewValue($ctrl.emptyValue);
                        if (!noselectcallback) {
                            $ctrl.onSelect({ $event: { item: $ctrl.emptyValue } });
                            //$ctrl.onSelect(null, $element);
                        }
                    });
                }
            }

            _updateDisplayedItem($ctrl);
        };

        $ctrl.show = function () {
            if (!$ctrl.readonly) {
                $ctrl.opened = true;
                $ctrl.listVisible = !$ctrl.listVisible || $ctrl.searchBox;
                if ($ctrl.listVisible) {
                    $document.on('click', _documentClick);//bind the click-away event

                    if (typeof (jQuery) !== 'undefined') {
                        $timeout(function () {
                            //Find vertical position of selected row
                            var verticalPosition = 0;
                            var $selectedRow = $element.find('.dropdown-list .selected');
                            if ($selectedRow.length) {
                                verticalPosition = $selectedRow.offsetParent().scrollTop() + $selectedRow.position().top;// - ($selectedRow.offsetParent().height() / 2);//halfway up scroller
                            }
                            $element.find('.dropdown-list').scrollTop(verticalPosition);//scroll to selected entry
                        });

                        //This delay must match the transition duration of the list opening in order to hide scrollbar whilst transitioning.
                        $timeout(function () { $ctrl.ddOpen = true; }, 400);
                    }
                } else {
                    $ctrl.ddOpen = false;
                    $document.off('click', _documentClick);//unbind the click-away event
                }
            }
        };

        function onModelChange() {
            _updateDisplayedItem($ctrl);
        }

        function _documentClick(e) {
            if ($element !== e.target && !$element[0].contains(e.target)) {
                //click away from element
                $document.off('click', _documentClick);//cancel the click-away when clicking off

                // Using evalasync to trigger refresh
                $scope.$evalAsync(function () {
                    $ctrl.listVisible = false;
                    $ctrl.ddOpen = false;
                    if ($ctrl.searchBox) {//if searchbox, clear text when nothing has been picked
                        if (!angular.equals($ctrl.selectedItem, $ctrl.emptyValue)) {
                            $ctrl.searchText = '';
                            $ctrl.onSearch({ $event: { text: $ctrl.searchText } });//return searched text to controller
                        }
                    }
                });
            } else {
                //clicked on element, do nothing as show and select methods do this
            }
        }

        // #endregion

        function $onInit() {
            //set up defaults
            initialiseController();
        }

        function $postLink() {
        }

        function $onChanges(changes) {
            if (_initialised) {
                if (changes.list) {
                    $ctrl.displayList = _rebuildDisplayList($ctrl);
                    if (!$ctrl.searchBox) {
                        _showDefaultItem($ctrl);
                        //if list has changed, check to see whether selection is present - if not, reset it to emptyValue.
                        var foundItem = _findItemInList($ctrl, $ctrl.model.$viewValue)

                        $ctrl.select((foundItem !== null ? foundItem : $ctrl.emptyValue), true);//select in list but do not trigger event (when not searching)
                        _updateValidity($ctrl);
                    }
                }

                if (changes.searchText) {
                    //console.log('searchText', $ctrl.searchText);
                    if ($ctrl.searchBox) {
                        // Clear the selected item when searching
                        $ctrl.selectedItem = angular.copy($ctrl.emptyValue);
                    }
                }

                //Update the validity state if the required attribute changes
                if (changes.requiredfield) {
                    _updateValidity($ctrl);
                }
            }
        }

        function $onDestroy() {
            $document.off('click', _documentClick);
        }

        function initialiseController() {
            //Handle parameters passed from the bindings

            if ($ctrl.expandUp) {
                angular.element($element).addClass('expandup');
            }

            $ctrl.requiredfield = !!$ctrl.requiredfield;//Coerce to false if undefined

            $ctrl.emptyValue = $ctrl.emptyValue || null;//emptyvalue defaults to null

            $ctrl.selectedItem = angular.copy($ctrl.emptyValue);

            // We need to bind to the model change events for this to work
            $ctrl.model.$viewChangeListeners.push(onModelChange);
            $ctrl.model.$render = onModelChange;

            if (!$ctrl.searchTimeout) $ctrl.searchTimeout = 0;
            if (typeof $ctrl.showGroupHeader === 'undefined') $ctrl.showGroupHeader = true;
            // Because default function wrappers are set after initial binding, our $ctrl.searchBox won't be affected by this.
            if (typeof $ctrl.onSearch !== 'function') $ctrl.onSearch = function () { };
            if (typeof $ctrl.onSelect !== 'function') $ctrl.onSelect = function () { };
            if (typeof $ctrl.onInvalid !== 'function') $ctrl.onInvalid = function () { };

            $ctrl.displayList = _rebuildDisplayList($ctrl);

            _showDefaultItem($ctrl);
            _updateValidity($ctrl);

            //console.log('dropdown', $ctrl.labelProperty, $ctrl.modelProperty, $ctrl.titleProperty);

            //Mark the controller as having been initialised, so that changes can start monitoring (prevents double-triggering)
            _initialised = true;
        }
    };

    app.component('dropdown', {
        require: {
            model: 'ngModel' // get the model directly from the ng-model declaration
        },
        bindings: {
            placeholder: '@',// Placeholder string for unselected appearance
            list: '<', // Values with which to populate the dropdown
            labelProperty: "@?",//property of list object to display as text
            modelProperty: "@?",//property of selection to return as model (optional)
            titleProperty: "@?",//property of selection to return as model (optional)
            groupProperty: "@?",//property of list to use as grouping header
            showGroupHeader: "<?",//Whether to show the group header as text
            emptyValue: '<?', // property value to ignore (and return if not selected). If null is a valid value, set emptyvalue to something you don't expect to return.

            readonly: '<?',
            requiredfield: '<?',

            maxHeight: '@?',//allows binding as direct value rather than needing to pass "'20rem'"
            expandUp: '<?',//Whether the box should expand upwards instead
            searchText: '<?',//model to modify search box text - if provided enables searchbox mode
            selectDefault: '<?',//select the only item if list length is 1.
            searchTimeout: '<?', //optional search timeout

            onSearch: '&?',//optional search callback - if provided enables searchbox mode
            onSelect: '&', //Required callback for selecting item
            onInvalid: '&?', // Optional callback for when the model passed does not exist in the list
        },

        controller: ['$document', '$timeout', '$element', '$scope', dropdownController],

        templateUrl: (typeof (tios) !== 'undefined' ? tios.util.cdnUrl('dist/angular/component/dropdown.html') : 'component/dropdown.html')
    });
})();